import { useState } from "react";
import { chooseTheme, currentTheme } from "../theme.ts";
import { ToggleWord } from "./ToggleWord.tsx";

/** Switches between the light page and the dark one. It names the one it switches to. */
export function ThemeToggle() {
  const [theme, setTheme] = useState(currentTheme);
  const other = theme === "dark" ? "light" : "dark";
  return (
    <ToggleWord
      className="theme-toggle"
      aria-label={`${other === "dark" ? "Dark" : "Light"}: switch to the ${other} page`}
      onClick={() => {
        chooseTheme(other);
        setTheme(other);
      }}
    >
      {other === "dark" ? "Dark" : "Light"}
    </ToggleWord>
  );
}
